import { computed, makeObservable } from 'mobx'

import { Collection } from 'modules/core/lib/mobx-rest'

import Card from 'modules/billing/store/models/Card'

class Cards extends Collection<Card> {
  constructor(data = []) {
    super(data)
    makeObservable(this, {
      current: computed,
    })
  }

  get cacheKey(): string {
    return 'cards'
  }

  model() {
    return Card
  }

  get current(): Card | undefined {
    return this.models[0]
  }
}

const singleton: Cards = new Cards()

export default singleton
